<template>
  <div class="calico-file-upload-page">
    <div class="calico-file-upload-container">
      <CalicoUploadFile
        :size="3"
        :files="files"
        @browse="onBrowse"
        @cancel="onCancel"
        @trash="onTrash"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoUploadFile from '@/components/pattern/uploadFile/index.vue'
export default {
  name: 'CalicoUploadFilePage',
  components: {
    CalicoUploadFile
  },
  data () {
    return {
      files: []
    }
  },
  methods: {
    onBrowse (files) {
      files = files.filter(xfile => !this.files.some(file => file.name === xfile.name))
      this.files = [...this.files, ...files]
      files.forEach((file) => {
        if (file.state !== 'failed') {
          const interval = setInterval(() => {
            const index = this.files.findIndex(xfile => xfile.name === file.name)
            if (index === -1) { 
              clearInterval(interval)
              return
            }
            this.files[index].progress += 1
            if (this.files[index].progress === 100) {
              this.files[index].state = 'completed'
              clearInterval(interval)
            }
          }, 10)
        }
      })
    },
    onCancel (file) {
      this.files = this.files.filter(xfile => xfile.name !== file.name)
    },
    onTrash (file) {
      this.files = this.files.filter(xfile => xfile.name !== file.name)
    }
  }
}
</script>
<style lang="scss">
.calico-file-upload-page {
  @include inline-space($space-none);
  justify-content: center;
  align-items: center;
  .calico-file-upload-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 459px;
  }
}
</style>